import {
  createSelectorHooks,
  type ZustandHookSelectors,
} from 'auto-zustand-selectors-hook';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { i18n } from '$/components/core/Localization/18n';

export type State = {
  dismissedStartDate: string | null;
};

type Actions = {
  dismissModal: () => void;
  shouldShowModal: () => boolean;
};

export const initial: State = {
  dismissedStartDate: null,
};

export const store = create<State & Actions>()(
  persist(
    (set, get) => ({
      ...initial,
      dismissModal: () => {
        set({ dismissedStartDate: i18n.t('whatsNew.startDate') });
      },
      shouldShowModal: () => {
        const rawStartDate = i18n.t('whatsNew.startDate');

        const { dismissedStartDate } = get();
        if (dismissedStartDate === rawStartDate) return false;

        const dateParts = rawStartDate.split('.');

        if (dateParts.length !== 3) return false;

        const [day, month, year] = dateParts.map(Number);

        if (Number.isNaN(day) || day < 1 || day > 31) {
          return false;
        }
        if (Number.isNaN(month) || month < 1 || month > 12) {
          return false;
        }
        if (Number.isNaN(year) || year < 2026) {
          return false;
        }

        const startDate = new Date(year, month - 1, day);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (today < startDate) return false;

        const diffTime = today.getTime() - startDate.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 7) return false;

        return true;
      },
    }),
    {
      name: 'whats-new-store',
      partialize: (state) => ({
        dismissedStartDate: state.dismissedStartDate,
      }),
    },
  ),
);

export const useWhatsNewStore = createSelectorHooks(store) as typeof store &
  ZustandHookSelectors<State & Actions>;
